import { render, staticRenderFns } from "./envelopeCouponModal.vue?vue&type=template&id=2dc32d31&scoped=true&"
import script from "./envelopeCouponModal.vue?vue&type=script&lang=js&"
export * from "./envelopeCouponModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc32d31",
  null
  
)

export default component.exports